var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderMoveOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:folder-move-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.333 12.0003L2.66634 12.0003L2.66634 5.33366L13.333 5.33366L13.333 12.0003ZM7.99967 4.00033L6.66634 2.66699L2.66634 2.66699C2.31272 2.66699 1.97358 2.80747 1.72353 3.05752C1.47348 3.30756 1.33301 3.6467 1.33301 4.00033L1.33301 12.0003C1.33301 12.3539 1.47348 12.6931 1.72353 12.9431C1.97358 13.1932 2.31272 13.3337 2.66634 13.3337L13.333 13.3337C14.073 13.3337 14.6663 12.7403 14.6663 12.0003L14.6663 5.33366C14.6663 4.98004 14.5259 4.6409 14.2758 4.39085C14.0258 4.1408 13.6866 4.00033 13.333 4.00033L7.99967 4.00033ZM7.33301 9.33366V8.00033L9.99967 8.00033V6.00033L12.6663 8.66699L9.99967 11.3337V9.33366L7.33301 9.33366Z",
    fill: "#00A0AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderMoveOutline);
export default __webpack_public_path__ + "static/media/folder-move-outline.0bceadc408fd251b01c4be5c0f40bf49.svg";
export { ForwardRef as ReactComponent };